import I18n from 'I18n';
import UIStepIndicator from 'UIComponents/connectedStep/UIStepIndicator';
import { useShareViaSettings } from './ShareViaSettingsContext';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareViaStepIndicator = () => {
  const {
    stepIndex
  } = useShareViaSettings();
  return /*#__PURE__*/_jsx(UIFlex, {
    className: "p-bottom-10",
    children: /*#__PURE__*/_jsx(UIStepIndicator, {
      direction: "horizontal",
      stepIndex: stepIndex,
      stepNames: [I18n.text('reporting-action-components.actions.shareVia.dialog.steps.sharingMethodStep.name'), I18n.text('reporting-action-components.actions.shareVia.dialog.steps.configurationStep.name')]
    })
  });
};
export default ShareViaStepIndicator;